import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form'
import { SxProps } from '@mui/material/styles'
import TextField, { TextFieldVariants } from '@mui/material/TextField'

type Props<Values extends FieldValues> = {
  name: FieldPath<Values>
  control: Control<Values>
  label?: string
  multiline?: boolean
  variant?: TextFieldVariants
  helperText?: string
  sx?: SxProps
  disabled?: boolean
  type?: string
  placeholder?: string
}

export const TextFieldController = <Values extends FieldValues>({
  name,
  control,
  variant = 'filled',
  helperText,
  multiline,
  disabled,
  sx,
  label,
  type,
  placeholder,
}: Props<Values>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, name, ref, ...field }, fieldState }) => (
        <TextField
          inputRef={ref}
          {...field}
          name={name}
          variant={variant}
          hiddenLabel={!label}
          label={label}
          onChange={onChange}
          multiline={multiline}
          disabled={disabled}
          fullWidth
          size="small"
          type={type}
          placeholder={placeholder}
          error={!!fieldState.error}
          helperText={fieldState.error?.message ?? helperText ?? undefined}
          sx={sx}
        />
      )}
    />
  )
}
